export { default } from './text';

export { default as ResponsiveText } from './responsive-text';

export * from './text-variants';

export * from './utils';
